import axios from 'axios';
import type { ReferralsResponseDto } from '@hotjar/webapp/domains/acquisition/referrals/dto';
import type { Referrals } from '@hotjar/webapp/domains/acquisition/referrals/types';
import { mapReferralsResponseDtoToModel } from '@hotjar/webapp/domains/acquisition/referrals/mapper';

/**
 * Fetch user referrals info.

 * @return {object} Object.
 */
export async function getReferralsByUserId(userId: string): Promise<Referrals> {
  const response: ReferralsResponseDto = await axios.get(`/api/v1/referrals/${userId}`);

  return mapReferralsResponseDtoToModel(response);
}
